// ProtectedSetupRoute.js
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box, Typography, Button } from '@mui/material';

const ProtectedSetupRoute = ({ children }) => {
  const { user, accessToken, guilds, fetchGuilds, userType, loading:authLoading } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // Change from boolean to nullable for error details

  const loadGuilds = async () => {
    console.log('ProtectedSetupRoute: loadGuilds called');
    setLoading(true);
    setError(null);
    try {
      await fetchGuilds();
      console.log('ProtectedSetupRoute: fetchGuilds succeeded');
      setLoading(false);
    } catch (err) {
      console.error('ProtectedSetupRoute: Error fetching guilds:', err);
      setError('Failed to fetch guilds. Please try again later.');
      setLoading(false);
    }
  };

  useEffect(() => {
    if (accessToken && (userType === 'admin' || userType === 'subscribe')) {
      console.log('ProtectedSetupRoute: Access token present and userType is admin or subscribe, fetching guilds');
      loadGuilds();
    } else {
      console.log('ProtectedSetupRoute: No access token or userType is not admin/subscribe');
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, userType]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: '0 20px',
        }}
      >
        <Typography variant="h6" color="error" gutterBottom>
          Oops! Something went wrong while fetching your guilds.
        </Typography>
        <Typography variant="body1" gutterBottom>
          {error}
        </Typography>
        <Button variant="contained" color="primary" onClick={loadGuilds}>
          Retry
        </Button>
      </Box>
    );
  }

  if (guilds.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: '0 20px',
        }}
      >
        <Typography variant="h6" gutterBottom>
          No Eligible Guilds Found
        </Typography>
        <Typography variant="body1" gutterBottom>
          You need to add the bot to at least one server where you have administrative permissions to proceed.
        </Typography>
        <Button variant="contained" color="primary" href="https://discord.com/oauth2/authorize?client_id=YOUR_CLIENT_ID&permissions=YOUR_PERMISSIONS&scope=bot">
          Add Bot to a Server
        </Button>
      </Box>
    );
  }

  // If all checks pass, render the protected component
  return children;
};

export default ProtectedSetupRoute;


